import { Box, ButtonChip, Flex, Text } from 'pcln-design-system';
import React, { useState } from 'react';
import analytics from '../../analytics';
export const ButtonChipsAction = props => {
  const {
    submitButtonChipActionMessage,
    hasOtherMessage,
    buttonChipsActions,
    isSeparatorMsg
  } = props;
  const [isButtonChipsActionsDisplayed, setButtonChipsActionsDisplayedValue] = useState(true);
  if (!isSeparatorMsg && (!buttonChipsActions.length || hasOtherMessage || !isButtonChipsActionsDisplayed)) {
    return null;
  }
  return React.createElement(Box, {
    p: 2,
    overflow: 'auto',
    width: 1,
    display: 'inline-flex'
  }, buttonChipsActions.map((action, i) => React.createElement(Flex, {
    key: `button-chip-action-button-${i}`,
    my: 2,
    mx: 0,
    alignItems: 'center'
  }, React.createElement(ButtonChip, {
    id: `buttonChip${i}`,
    m: 1,
    onClick: function () {
      submitButtonChipActionMessage(action);
      setButtonChipsActionsDisplayedValue(false);
      analytics.log({
        label: 'buttonChipActions',
        message: 'BUTTON_CHIP_ACTION_BUTTON_CLICKED',
        content: action.label
      });
    }
  }, React.createElement(Box, {
    px: 3,
    py: 1
  }, React.createElement(Text, {
    textAlign: 'center',
    bold: true,
    fontSize: 1
  }, action.label), React.createElement(Text, {
    textAlign: 'center',
    regular: true,
    fontSize: 0
  }, action.description))))));
};